import Page from 'flarum/common/components/Page';
import { extend, override } from 'flarum/common/extend';
import classList from 'flarum/common/utils/classList';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import sortTags from 'flarum/tags/common/utils/sortTags';
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import extractText from 'flarum/common/utils/extractText';

import CategoriesSelect from './CategoriesSelect';
export default class CustomFilterNav extends Component {
  oninit(vnode: any) {
    super.oninit(vnode);
    this.categoryValue = '';
    this.subCategoryValue = '';
    this.sortValue = '';
    this.bestAnswerSortValue = '';

    // 处理URL中的tags参数
    const tagName = m.route.param('tags') || '';
    if (tagName) {
      const allTags = app.store.all('tags');
      const currentTag = allTags.find((tag) => tag.slug() === tagName);

      if (currentTag && currentTag.isChild()) {
        // 如果是子分类，设置subCategoryValue为当前tag，categoryValue为父分类的slug
        this.subCategoryValue = tagName;
        this.categoryValue = currentTag.parent().slug();
      } else {
        // 如果不是子分类，categoryValue直接等于tagName
        this.categoryValue = tagName;
      }
    }
  }
  view() {
    return <ul className="category-select-container">{listItems(this.filterItems().toArray())}</ul>;
  }
  filterItems() {
    const allTags = app.store.all('tags');
    const tags = sortTags(allTags.filter((tag) => tag.isPrimary()));
    const categoryOptions = tags.map((tag: any) => ({
      label: tag.name(),
      value: tag.slug(),
      color: tag.color(),
      slug: tag.slug(),
      // count: tag.postCount(),
      description: tag.description(),
    }));
    const items = new ItemList<Mithril.Children>();
    items.add(
      'primaryCategorySelect',
      <CategoriesSelect
        className="primary-category-select category-select"
        options={categoryOptions}
        value={this.categoryValue}
        placeholder={app.translator.trans('dvdfab-homepage.forum.category_placeholder')}
        showRemoveFilter={true}
        removeFilterLabel={app.translator.trans('dvdfab-homepage.forum.remove_filter_label')}
        // 自定义选项渲染
        optionRender={(option, { index }) => (
          <div className="category-option">
            <span className="category-color" style={{ backgroundColor: option.color }}></span>
            <div className="category-info">
              <div className="category-name">{option.label}</div>
            </div>
          </div>
        )}
        // 自定义选中项渲染
        labelRender={(option) => (
          <div className="selected-category">
            <span className="category-color" style={{ backgroundColor: option.color }}></span>
            <span className="category-name">{option.label}</span>
          </div>
        )}
        onchange={(value: string) => {
          // const targetSlug = categoryOptions.find((item) => item.value === value)?.slug;
          if (app.discussions && app.discussions.bestAnswer !== undefined) {
            delete app.discussions.bestAnswer;
          }

          // 获取当前URL的搜索参数
          const currentParams = { ...m.route.param() };
          delete currentParams.tags; // 移除tags参数，因为我们要设置新的

          if (value === 'removeFilter') {
            m.route.set(app.route('tags'));
            return;
          }

          // 合并当前参数和新的tags参数
          const newParams = { ...currentParams, tags: value };
          m.route.set(app.route('tag', newParams));
          // this.categoryValue = value;
        }}
      />
    );

    const routeName = app.current.get('routeName');
    // index tag tags following byobuPrivate
    if (routeName === 'tag') {
      const subTags = sortTags(allTags.filter((tag: any) => tag.isChild()));
      const subCategoryOptions = subTags
        .map((tag: any) => ({
          label: tag.name(),
          value: tag.slug(),
          color: tag.color(),
          slug: tag.slug(),
          // count: tag.postCount(),
          description: tag.description(),
          parentSlug: tag.parent() ? tag.parent().slug() : '',
        }))
        .filter((item) => item.parentSlug === this.categoryValue);
      if (subCategoryOptions.length) {
        items.add(
          'subCategorySelect',
          <CategoriesSelect
            className="primary-category-select category-select"
            options={subCategoryOptions}
            value={this.subCategoryValue}
            placeholder={app.translator.trans('dvdfab-homepage.forum.sub_category_placeholder')}
            showRemoveFilter={true}
            removeFilterLabel={app.translator.trans('dvdfab-homepage.forum.remove_filter_label')}
            // 自定义选项渲染
            optionRender={(option, { index }) => (
              <div className="category-option">
                <span className="category-color" style={{ backgroundColor: option.color }}></span>
                <div className="category-info">
                  <div className="category-name">{option.label}</div>
                </div>
              </div>
            )}
            // 自定义选中项渲染
            labelRender={(option) => (
              <div className="selected-category">
                <span className="category-color" style={{ backgroundColor: option.color }}></span>
                <span className="category-name">{option.label}</span>
              </div>
            )}
            onchange={(value: string) => {
              // const targetSlug = categoryOptions.find((item) => item.value === value)?.slug;
              if (app.discussions && app.discussions.bestAnswer !== undefined) {
                delete app.discussions.bestAnswer;
              }

              // 获取当前URL的搜索参数
              const currentParams = { ...m.route.param() };
              delete currentParams.tags; // 移除tags参数，因为我们要设置新的

              // this.subCategoryValue = value;
              if (value === 'removeFilter') {
                m.route.set(app.route('tag', { tags: this.categoryValue }));
                return;
              }

              // 合并当前参数和新的tags参数
              const newParams = { ...currentParams, tags: value };
              m.route.set(app.route('tag', newParams));
              // this.categoryValue = value;
            }}
          />
        );
      }
    }

    const bestKeys = ['all', 'solved', 'unsolved'];
    const bestAnswerOptions = bestKeys.map((key, index) => ({
      label: app.translator.trans(`fof-best-answer.forum.filter.${key}_label`),
      value: `${index}`,
    }));
    if (app.current.matches(IndexPage)) {
      this.bestAnswerSortValue = app.discussions && app.discussions.bestAnswer ? app.discussions.bestAnswer : '';
    }
    items.add(
      'bestAnswerSort',
      <CategoriesSelect
        className="primary-category-select category-select"
        options={bestAnswerOptions}
        value={this.bestAnswerSortValue}
        placeholder={app.translator.trans('dvdfab-homepage.forum.tags_placeholder')}
        // 自定义选项渲染
        optionRender={(option, { index }) => (
          <div className="category-option">
            <div className="category-info">
              <div className="category-name">{option.label}</div>
            </div>
          </div>
        )}
        // 自定义选中项渲染
        labelRender={(option) => (
          <div className="selected-category">
            <span className="category-name">{option.label}</span>
          </div>
        )}
        onchange={(value: string) => {
          // this.sortValue = value;
          // app.search.changeSort.bind(app.search, value)
          // app.search.changeSort.call(app.search, value);
          // 跳转到/all页面并携带sort参数

          if (app.current.matches(IndexPage)) {
            if (app.discussions) {
              app.discussions.bestAnswer = value;
              if (value === '0') {
                delete app.discussions.bestAnswer;
              }
              app.discussions.refresh();
            }
          } else {
            m.route.set(app.route('index'));
            if (app.discussions) {
              app.discussions.bestAnswer = value;
              if (value === '0') {
                delete app.discussions.bestAnswer;
              }
            }
          }
        }}
      />
    );
    if (app.current.matches(IndexPage)) {
      const sortMap = app.discussions.sortMap();
      const sortOptions = Object.keys(sortMap).reduce((acc: any, sortId) => {
        acc[sortId] = app.translator.trans(`core.forum.index_sort.${sortId}_button`);
        return acc;
      }, {});
      const formatSortOptions = Object.keys(sortOptions).map((key) => ({
        label: sortOptions[key]?.[0] ? sortOptions[key]?.[0] : sortOptions[key],
        value: key,
      }));
      this.sortValue = app.search.params().sort || formatSortOptions[0].value;

      items.add(
        'sort',
        <CategoriesSelect
          className="primary-category-select category-select"
          options={formatSortOptions}
          value={this.sortValue}
          placeholder=""
          // 自定义选项渲染
          optionRender={(option, { index }) => (
            <div className="category-option">
              <div className="category-info">
                <div className="category-name">{option.label}</div>
              </div>
            </div>
          )}
          // 自定义选中项渲染
          labelRender={(option) => (
            <div className="selected-category">
              <span className="category-name">{option.label}</span>
            </div>
          )}
          onchange={(value: string) => {
            // app.search.changeSort.bind(app.search, value)
            // app.search.changeSort.call(app.search, value);
            // 跳转到/all页面并携带sort参数
            // m.route.set(app.route('index', { sort: value }));
            this.sortValue = value;
            app.search.changeSort.call(app.search, value);
          }}
        />
      );
    }

    return items;
  }
}
